import {AfterViewInit, Directive, ElementRef} from '@angular/core';

declare var $: any;

@Directive({
  selector: '[appScrollOffset]'
})
export class ScrollOffsetDirective implements AfterViewInit {

  constructor(private el: ElementRef) {
  }

  scrollOffset() {
    const $this = this.el.nativeElement;
    return $('body, html').animate({
      scrollTop: $($this).offset().top - 50
    }, 1500);
  }

  ngAfterViewInit(): void {
    this.scrollOffset();
  }

}
